import React from "react";

function VerdictBanner({ label, tone = "neutral", helper }) {
  const toneMap = {
    success: "positive",
    warning: "warn",
    danger: "negative"
  };
  const resolvedTone = toneMap[tone] || tone;
  const classes = ["ui-verdict-banner", `ui-verdict-banner--${resolvedTone}`]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role="status">
      <span className="ui-verdict-banner__title">{label}</span>
      {helper && <span className="ui-verdict-banner__subtitle">{helper}</span>}
    </div>
  );
}

export default VerdictBanner;
